import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import VuiButton from 'components/VuiButton';
import VuiTypography from 'components/VuiTypography';

const PopUp = ({ onClick }) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState(null)
    const [colorAlert, setColorAlert] = useState(null)

    const action = async () => {
        const { success, message } = await onClick();
        setColorAlert(success ? "grenn" : "red");
        setMessage(message);
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setMessage(null);
        setOpen(false);
    };

    const create = () => {
        handleOpen();
    };

    return (
        <div>
            <VuiButton onClick={create} color="info" variant={"contained"}>
                <VuiTypography
                    color="white"
                    sx={{
                        fontSize: "14px",
                        fontWeight: "700",
                        lineHeight: "21px",
                    }}
                    >
                  Canjear vidas
                </VuiTypography>
            </VuiButton>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Canjear vidas</DialogTitle>
                <DialogContent>
                    {(
                        message &&
                        <p style={{ color: colorAlert, fontSize: "1rem", textAlign: "center" }}>
                            {message}
                        </p>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={action} color="primary">
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default PopUp;
